import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ToastrService } from 'core/toastr.service';
import { MfaMethod } from "generated/graphql";

export interface IGraphQLErrorExtensions {
  code?: string;
  mfa_method?: string;
  masked_phone?: string;
  message?: string;
}

export interface IGraphQLError {
  message: string;
  code: number;
  locations: any;
  path: any;
  extensions?: IGraphQLErrorExtensions;
}

@Injectable({ providedIn: 'root' })
export class ApolloErrorHandlerService {

  constructor(
    private router: Router,
    private toastrService: ToastrService
  ) {}

  handleError(graphQlError: IGraphQLError) {
    // https://github.com/ActionNetwork/interact/blob/1bceeaa91b624459cb3307c4d4e8255942a15979/config/error_codes.yml
    if (!graphQlError) {
      return;
    }

    const { code, message, extensions } = graphQlError;

    // Setup is complete, but we need to verify the code for the current session.
    const needsVerification = extensions?.code === "MFA_VERIFICATION_REQUIRED";
    const requiresSetup = extensions?.code === "MFA_SETUP_REQUIRED";

    if (needsVerification || requiresSetup) {
      let redirectUrl = needsVerification ? "/verify_mfa" : "/setup_mfa";
      const params = new URLSearchParams({});

      if (extensions?.mfa_method) {
        params.set("mfaMethod", String(extensions.mfa_method));

        if (extensions.masked_phone) {
          params.set("maskedPhone", extensions.masked_phone);
        }
      }

      if (requiresSetup) {
        params.set("orgRequired", "true");
      }

      redirectUrl = `/${redirectUrl}?${params.toString()}`;

      this.router.navigateByUrl(redirectUrl);
      return;
    }

    switch (code) {
      case 1001:
        this.toastrService.errorSkipLog(message);
        this.router.navigateByUrl('/login');
        break;
      case 1102:
      // Campaign Not Accessible
        this.toastrService.errorSkipLog(message);
        this.router.navigateByUrl('/select-campaign');
        break;
      default:
        this.toastrService.errorSkipLog(message);
        break;
    }
  }
}
